(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-animated-background"] && !Shopify.designMode) return;
  try {
    
	$(document).on("scroll", function () {
		var windowTop = $(window).scrollTop();
		if ($(".flower__wrapper").isInViewport) {
		
		var elementTop = $(".flower__wrapper").offset().top;
		  
		var leftPosition = (windowTop - elementTop);
		  leftPosition = leftPosition / 100;
		  var switch_dir = (leftPosition < 0) ? (leftPosition * -1) : "-" +leftPosition ;
		  $(this)
			.find(".flower__wrapper .flower__row:odd")
			.css({ '-webkit-transform': "translateX(" + switch_dir+ "%)",
				   '-moz-transform': "translateX(" + switch_dir+ "%)",
				   '-ms-transform': "translateX(" + switch_dir+ "%)",
				   '-o-transform': "translateX(" + switch_dir+ "%)",
				 'transform': "translateX(" + switch_dir+ "%)"});
	
		  $(this)
			.find(".flower__wrapper .flower__row:even")
		  .css({'-webkit-transform': "translateX(" + leftPosition+ "%)",
				 '-moz-transform': "translateX(" + leftPosition+ "%)",
				 '-ms-transform': "translateX(" + leftPosition+ "%)",
				 '-o-transform': "translateX(" + leftPosition+ "%)",
			   'transform': "translateX(" + leftPosition + "%)"});;
		}
	
	
	});

  } catch(e) { console.error(e); }
})();
})();
